<template>
  <div>
    <el-row style="top: 17px;width:96%;margin:auto">
      <!-- 模糊查询 -->
      <div>
        <el-form
          :model="queryForm"
          label-position="right"
          ref="queryForm"
          label-width="70px"
          class="systemFont1"
        >
          <!-- 课程名称 -->
          <el-col :span="6">
            <el-form-item :label="$t('p0331.courseTitle')" style="margin-bottom: 22px">
              <el-input
                name="queryForm.searchCourseName"
                type="text"
                v-model="queryForm.searchCourseName"
                clearable
                :placeholder="$t('p0331.courseTitle')"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 上课时间 -->
          <el-col :span="5" :offset="1">
            <el-form-item :label="$t('p0331.classTime')" style="margin-bottom: 22px">
              <el-date-picker
                v-model="queryForm.searchDateAndTime"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :placeholder="$t('p0352.selectDate')"
                style="width:100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- 收件人姓名/联系电话 -->
          <el-col :span="6" :offset="1">
            <el-form-item :label="$t('p0352.keywords')" style="margin-bottom: 22px">
              <el-input
                name="queryForm.searchCriteria"
                type="text"
                v-model="queryForm.searchCriteria"
                clearable
                :placeholder="$t('p0352.recipientinfo')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <img
              src="../../assets/query2.svg"
              width="36px"
              height="36px"
              style="cursor: pointer;"
              @click="init(true)"
            />
          </el-col>
          <!-- 导出发票信息 -->
          <el-col :span="3">
            <el-button type="exportInfo" style="margin-top:5px" @click.native.prevent="exportOfInvoiceInfo">{{$t("p0352.exportOfInvoiceInfo")}}</el-button>
          </el-col>
        </el-form>
      </div>
      <el-col :span="22" :offset="1">
        <el-row><br /></el-row>
      </el-col>
    </el-row>
    <el-row style="top: 17px">
      <el-col style="width:100%">
        <el-table
          :data="mtblInvoicesList"
          style="width: 100%; margin-bottom: 75px">
          <!-- 收件人姓名 -->
          <el-table-column
            prop="recipientName"
            :label="$t('p0352.recipientName')"
            align="left"
            min-width="90">
          </el-table-column>
          <!-- 联系电话 -->
          <el-table-column
            prop="recipientTelephone"
            :label="$t('p0352.contactNumber')"
            align="center"
            min-width="100">
          </el-table-column>
          <!-- 报名时间 -->
          <el-table-column
            prop="applicantsTime"
            :formatter="applicantsTimeFormat"
            :label="$t('p0352.registrationTime')"
            align="center"
            min-width="140">
          </el-table-column>
          <!-- 发票类型 -->
          <el-table-column
            prop="invoiceTypeName"
            :label="$t('p0352.invoiceType')"
            align="center"
            min-width="110">
          </el-table-column>
          <!-- 课程名称 -->
          <el-table-column
            prop="courseName"
            :label="$t('p0352.courseName')"
            align="left"
            min-width="115">
          </el-table-column>
          <!-- 上课时间 -->
          <el-table-column
            :formatter="dateAndTimeFormat"
            prop="dateAndTime"
            :label="$t('p0352.classTime')"
            align="center"
            min-width="120">
          </el-table-column>
          <!-- 开具时间 -->
          <el-table-column
            :formatter="invoicingTimeFormat"
            prop="invoicingTime"
            :label="$t('p0352.timeOfIssue')"
            align="center"
            min-width="140">
          </el-table-column>
          <el-table-column
            :label="$t('common.operation')"
            align="center"
            min-width="100">
            <template slot-scope="scope">
              <el-button @click="viewInvoiceInfo(scope.row)" type="text">{{$t('p0352.viewInvoiceInfo')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row style="text-align: right; margin: 20px">
          <el-col :span="24">
            <div class="block">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPageCo"
                :page-sizes="[20, 50]"
                :page-size="pageSizeCo"
                layout="total, sizes, prev, pager, next"
                :total="totalCo"
              >
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog
      :title="$t('p0352.invoiceInfo')"
      width="450px"
      :visible.sync="dialogFormVisible"
    >
      <el-divider></el-divider>
      <el-form :model="dialogForm" ref="dialogFormRef" style="text-align:left;margin-left:50px;margin-bottom:20px">
        <!-- 发票类型 -->
        <el-form-item :label="$t('p0352.invoiceTypeDialog')"><span>{{dialogForm.invoiceTypeName}}</span></el-form-item>
        <!-- 发票抬头 -->
        <el-form-item :label="$t('p0352.invoiceTitle')"><span>{{dialogForm.invoiceHeader}}</span></el-form-item>
        <!-- 入账总额 -->
        <el-form-item :label="$t('p0352.totalAmount')"><span>{{dialogForm.entryPrice}}&nbsp;{{dialogForm.currency}}</span></el-form-item>
        <!-- 服务项目 -->
        <el-form-item :label="$t('p0352.serviceItems')"><span>{{dialogForm.serviceItemsName}}</span></el-form-item>
        <!-- 纳税人识别号 -->
        <el-form-item :label="$t('p0352.TaxpayeridentifyNo')"><span>{{dialogForm.taxpayerIdentificationNumber}}</span></el-form-item>
        <!-- 公司注册地址 -->
        <el-form-item :label="$t('p0352.companyRegistAdd')"><span>{{dialogForm.registeredAddress}}</span></el-form-item>
        <!-- 公司财务电话 -->
        <el-form-item :label="$t('p0352.CorporateFinancialTel')"><span>{{dialogForm.companyFinancialTelephone}}</span></el-form-item>
        <!-- 开户银行 -->
        <el-form-item :label="$t('p0352.bankOfDeposit')"><span>{{dialogForm.bankName}}</span></el-form-item>
        <!-- 银行账号 -->
        <el-form-item :label="$t('p0352.bankAccountNo')"><span>{{dialogForm.bankAccount}}</span></el-form-item>
        <!-- 领取方式 -->
        <el-form-item :label="$t('p0352.wayOfReceive')"><span>{{dialogForm.collectionMethodName}}</span></el-form-item>
        <!-- 收件人姓名 -->
        <el-form-item :label="$t('p0352.recipientnName')"><span>{{dialogForm.recipientName}}</span></el-form-item>
        <!-- 联系电话 -->
        <el-form-item :label="$t('p0352.contactNo')"><span>{{dialogForm.recipientTelephone}}</span></el-form-item>
        <!-- 邮递地址 -->
        <el-form-item :label="dialogForm.collectionMethod==1 ? $t('p0352.email'):$t('p0352.postalAdd')">
          <span v-if="dialogForm.collectionMethod==1">{{dialogForm.recipientEmail}}</span>
          <span v-else>{{dialogForm.postalAddress}}</span>
        </el-form-item>
        <!-- 备注 -->
        <el-form-item :label="$t('p0352.remarks')"><span>{{dialogForm.remarks}}</span></el-form-item>
        <!-- 电子邮箱 -->
        <!-- <el-form-item :label="$t('p0352.email')"><span>{{dialogForm.recipientEmail}}</span></el-form-item> -->
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import moment, { now } from "moment";
export default {
  data() {
    return {
      // 弹框
      dialogFormVisible: false,
      // 一览数据
      mtblInvoicesList: [
        {
          recipientName: "",
          recipientTelephone: "",
          applicantsTime: "",
          invoiceType: '',
          invoiceTypeName:"",
          courseName: "",
          dateAndTime: '',
          invoicingTime:"",
        },
      ],
      // 查询条件
      queryForm: {
        searchCourseName: "",
        searchDateAndTime: "",
        searchCriteria: "",
      },
      // 弹框数据
      dialogForm:{
        invoiceType: "",
        invoiceTypeName:"",
        invoiceHeader:"",
        serviceItemsName:"",
        taxpayerIdentificationNumber:"",
        registeredAddress:"",
        companyFinancialTelephone:"",
        bankName:"",
        bankAccount:"",
        collectionMethod:"",
        recipientName:"",
        recipientTelephone:"",
        detailedAddress:"",
        recipientEmail:"",
        province:"",
        city:"",
        area:"",
        postalAddress:"",
        entryPrice:"",
        currency:"",
        remarks: "",
      },
      // 当前页
      currentPageCo: 1,
      // 每页件数
      pageSizeCo: 20,
      totalCo: 0,
    }
  },
  methods: {
    // 每页数据条数设定
    handleSizeChange(val) {
      this.pageSizeCo = val;
      this.currentPageCo = 1;
      //判断更改页码是否需要查询
      if (this.classInvitationData == undefined || this.classInvitationData.length <= 0) {
        return;
      }
      this.init(false);
      // console.log(`每页 ${val} 条`);
    },

    handleCurrentChange(val) {
      this.currentPageCo = val;
      this.init(false);
      // console.log(`当前页: ${val}`);
    },

    // 初始化一览数据
    init(val) {
    const loading = this.$loading({
      lock: true,
      text: this.$t('common.loading'),
      background: "rgba(255,255,255,0.8)",
      target: document.querySelector("#main-container"),
    });
    if (val) {
      // 分页数据初始化
      this.currentPageCo = 1;
      this.totalCo = 0;
    }
    let url = "/api/greenJacketInvoice/searchInvoicesIssued"
    this.$http
      .post(url, qs.stringify({
        searchCourseName: this.queryForm.searchCourseName,
        searchDateAndTime: this.queryForm.searchDateAndTime,
        searchCriteria: this.queryForm.searchCriteria,
        currentSizeCo: (this.currentPageCo - 1) * this.pageSizeCo,
        pageSizeCo: this.pageSizeCo,
        totalCo: this.totalCo,
        currentPageCo: this.currentPageCo,
      }))
      .then((response) => {
        loading.close()
        if (response.data.code === 200) {
          // console.log("response.data.data.mTblInvoicesList",JSON.stringify(response.data.data) )
          this.mtblInvoicesList=response.data.data.mtblInvoicesList
            //判断是否初始化
          if (this.currentPageCo == 1) {
            this.mtblInvoicesList=response.data.data.mtblInvoicesList
            this.totalCo = response.data.data.totalCo;
          } else {
            this.mtblInvoicesList=response.data.data.mtblInvoicesList
          }
        } else {
          this.mtblInvoicesList=[]
          this.$message.error(response.data.message)
        }
      })
      .catch((err) => {
        console.log(err)
        loading.close()
        this.$message.error(this.$t('common.anErrorOccurred'))
      });
  },

    //格式化上课时间
    dateAndTimeFormat(row) {
      if(row.dateAndTime!=null&&row.dateAndTime!=""){
        return moment(row.dateAndTime).format("YYYY-MM-DD HH:mm");
      }
    },
    //格式化报名时间
    applicantsTimeFormat(row){
      if(row.applicantsTime!=null&&row.applicantsTime!=""){
        return moment(row.applicantsTime).format("YYYY-MM-DD HH:mm:ss");
      }
    },
    //格式化开具时间
    invoicingTimeFormat(row){
      if(row.invoicingTime!=null&&row.invoicingTime!=""){
        return moment(row.invoicingTime).format("YYYY-MM-DD HH:mm:ss");
      }
    },
    // 发票信息导出
    exportOfInvoiceInfo(){
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container"),
      });
      let url = "/api/greenJacketInvoice/exportInvoicesIssued?searchCourseName=" + this.queryForm.searchCourseName+"&searchDateAndTime=" + this.queryForm.searchDateAndTime+"&searchCriteria=" + this.queryForm.searchCriteria;
      this.$http
        .get(url,{ responseType: "blob"})
        .then((response) => {
          console.log("文件下载成功", response.data);
          const blob = new Blob([response.data]);
          console.log("blob", blob);
          this.formVisible = false;
          if (blob.size == 0) {
            this.$message({
            message: this.$t("p0352.noInvoiceInfoExport"),
            type: 'warning'
          });
            loading.close();
          } else {
            const fileName = this.$t("p0352.invoiceInfoExportTitle")+ moment(now()).format("YYYY-MM-DD") +this.$t("p0352.exportFileFormat");
            //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
            //IE10以上支持blob，但是依然不支持download
            if ("download" in document.createElement("a")) {
              console.log("download1");
              //支持a标签download的浏览器
              const link = document.createElement("a"); //创建a标签
              link.download = fileName; //a标签添加属性
              link.style.display = "none";
              link.href = URL.createObjectURL(blob);
              document.body.appendChild(link);
              link.click(); //执行下载
              URL.revokeObjectURL(link.href); //释放url
              document.body.removeChild(link); //释放标签
            } else {
              // console.log("download2");
              navigator.msSaveBlob(blob, fileName);
            }
            loading.close();
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(this.$t("p0352.invoiceInfoExportFail"));
          loading.close();
        });
    },
    // 查看发票信息
    viewInvoiceInfo(row){
      // 弹框
      this.dialogFormVisible=true
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container"),
      });
      let url = "/api/greenJacketInvoice/searchInvoiceInfoById";
      this.$http
        .post(url, qs.stringify({
          invoiceId: row.invoiceId,
        }))
        .then(response => {
          if (response.data.code === 200) {
            this.dialogForm=response.data.data
            if(!this.dialogForm.province){
              this.dialogForm.province=""
            }
            if(!this.dialogForm.city){
              this.dialogForm.city=""
            }
            if(!this.dialogForm.area){
              this.dialogForm.area=""
            }
            if(!this.dialogForm.detailedAddress){
              this.dialogForm.detailedAddress=""
            }
            this.dialogForm.postalAddress=this.dialogForm.province+this.dialogForm.city+this.dialogForm.area+this.dialogForm.detailedAddress
            // 入账总额不为空时显示总额+货币
            if(this.dialogForm.entryPrice!=null && this.dialogForm.entryPrice!=""){
              // 货币
              // this.dialogForm.currency="CNY"
              // 入账总额显示货币格式
              var price = "";
              price = this.dialogForm.entryPrice.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
              if (price.includes(".")) {
                price = price.split(".")[1].length < 2 ? price + "0" : price;
              } else {
                price += ".00";
              }
              this.dialogForm.entryPrice=price
            }
          } 
          loading.close();
        })
        .catch(err => {
          loading.close();
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    }
  },
  mounted() {
    this.init(true);
  }

}
</script>

<style lang="scss" scoped>

>>>.el-table thead{
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
  color: #333333;
  font-size: 16px;
}

>>>.el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170)
}

>>>.el-table__row {
  height: 42px;
}

>>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>>.el-table--border::after, .el-table--group::after, .el-table::before{
  background: none;
}
/* 导出发票信息 */
.el-button--exportInfo {
  background-color: #00B0F0;
  border-color: rgb(0, 176, 240);
  width: 112px;
  height: 30px;
  white-space: pre-wrap;
  padding: 0;
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  color: #FFFFFF;
  font-size: 13px;
  line-height: 18px;
}
>>>.el-divider--horizontal{
  margin: 14px 0;
}
>>>.el-dialog__body{
  padding:10px 20px;
}
>>>.el-form-item{
  margin-bottom: 0px
}
</style>



// WEBPACK FOOTER //
// src/views/GreenJacketForum/P0353.vue